import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { routeService } from '../../../../application/RouteService';
import { Route } from '../../../../domain/route/Route';

interface UseDeleteRouteProps {
  route: Route;
}

type UseDeleteRouteResponseProps = ServiceResponse<({ route }: UseDeleteRouteProps) => void, void>;

// Hooks act as 'Adapter' layer.
export const useDeleteRoute = (): UseDeleteRouteResponseProps => {
  const queryClient = useQueryClient();

  const { isLoading, isSuccess, isError, mutate } = useMutation(
    ({ route }: UseDeleteRouteProps) => routeService.deleteRoute({ route }),
    {
      onSettled: () => {
        queryClient.invalidateQueries([`route-list`]);
      },
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    run: mutate,
  };
};
